import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

export function formatIntlPhoneNumber(
  phoneNumber: string,
  defaultCountry: CountryCode = 'FR',
): string {
  const parsed = parsePhoneNumberFromString(phoneNumber, defaultCountry);

  if (parsed && parsed.isValid()) {
    return parsed.formatInternational(); // Returns the phone number in international format
  }

  return phoneNumber; // Fallback to the original input if parsing fails
}
